import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class ServiceDetails extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'
        let imagealt = 'image'

        return	<section className="service-details">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 clearfix">
                        <img src={publicUrl+"assets/images/resources/real-time-dashboard.jpg"} alt={ imagealt } className="float-right wow fadeInLeft" data-wow-duration="1500ms" />
                    </div>{/* /.col-lg-6 */}
                    <div className="col-lg-6">
                        <div className="service-details__content">
                            <h3>Track performance, customer activity,<br /> and conversation quality.</h3>
                            <p>Gain complete control over your customer interactions with a powerful, real-time dashboard designed to give you actionable insights. Monitor conversations, track lead activity, and evaluate performance — all from a single, secure platform.</p>
                            <p>Whether it’s understanding user behavior or identifying high-quality leads, your dashboard ensures you always stay informed and ready to act.</p>

                        </div>{/* /.service-details__content */}
                    </div>{/* /.col-lg-6 */}
                </div>{/* /.row */}
                <div className="row">
                    <div className="col-lg-6">
                        <img src={publicUrl+"assets/images/resources/service-detail-22.jpg"} alt={ imagealt } className="wow fadeInRight" data-wow-duration="1500ms" />
                    </div>{/* /.col-lg-6 */}
                    <div className="col-lg-6">
                        <div className="service-details__content">
                            <h3>Our secure business portal gives you complete visibility into:</h3>
                            <ul className="list-unstyled service-details__list">
                                <li>
                                    Live leads
                                </li>
                                <li>Conversation history</li>
                                <li>Conversion reports</li>
                                <li>Team handover requests</li>
                            </ul>{/* /.list-unstyled service-details__list */}
                        </div>{/* /.service-details__content */}
                    </div>{/* /.col-lg-6 */}
                </div>{/* /.row */}
            </div>{/* /.container */}
        </section>

    }
}

export default ServiceDetails